import React from 'react';
import './Home.css';
const Inventario = ({submenu}) => {
    return (
        <div className="home">
            <div>
                <h2 className = "home-pag-name">Inventario</h2>
                <p>Esta es la página principal de Inventario</p>
                <p>{submenu}</p>
            </div>
        </div>
    );
}

export default Inventario;